import { render, staticRenderFns } from "./widget-MSKU.vue?vue&type=template&id=5732f24c&scoped=true&"
import script from "./widget-MSKU.vue?vue&type=script&lang=js&"
export * from "./widget-MSKU.vue?vue&type=script&lang=js&"
import style0 from "./widget-MSKU.vue?vue&type=style&index=0&id=5732f24c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732f24c",
  null
  
)

export default component.exports